export default __webpack_public_path__ + "static/HalvarBreit-Rg-4a5441d84cf3480a169841a0881e37d0.woff";